export default __webpack_public_path__ + "6433a56c59fc4ba4fe1430ebb05c5634.png";